import React from 'react'
import { Box } from '@mui/material'
import Head from 'next/head'

import { LayoutProps } from '../types'

import { getDeviceType } from '#/shared/lib/helpers'

export const LayoutWithoutSideMenu = ({ children, titlePage, device = getDeviceType() }: LayoutProps) => {
	const desktop = device === 'desktop'


	return (
		<>
			<Head>
				{titlePage && <title>{titlePage}</title>}
				<meta name='AIR' />
				<meta name='viewport' content='width=device-width, initial-scale=1' />
				<link rel='icon' href='/logo.svg' />
				<link rel='apple-touch-icon' href='/logo180.png'></link>
				<link rel='manifest' href='/manifest.json' />
			</Head>
			<Box
				id={'layout'}
				sx={{
					width: '100%',
					height: desktop ? '100%' : '100vh',
				}}
			>
				<Box
					sx={{
						padding: desktop ? '0px' : '1px',
					}}
				>
					{children}
				</Box>
			</Box>
		</>
	)
}
